import { QueryList } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

export function commitPendingTags(inputs: QueryList<NgSelectComponent>): void {
    if (!inputs) {
        return;
    }
    inputs.forEach(input => {
        if (input && input.showAddTag) {
            input.selectTag();
        }
    });
}

export function clearPendingTags(inputs: QueryList<NgSelectComponent>): void {
    if (!inputs) {
        return;
    }
    inputs.forEach(input => {
        if (input) {
            input.handleClearClick();
        }
    });
}
